$(document).ready(function() {
    function initializeCustomizer() {
        var h1Text = $("h1").text();
        var button = $(".product-form__submit");
        var MaxquantityChick = 0;
        var noSubmit = 0;

        if (h1Text === "Muscle Gain Combo A - 6 meals" || h1Text === "Weight Loss COMBO A - 6 meals") {
            $('.product-form__input.product-form__quantity').hide(); // Hide the quantity input for Combo A
            MaxquantityChick = 6;
        } else if (h1Text === "Muscle Gain COMBO B - 12 meals" || h1Text === "Weight Loss COMBO B - 12 meals") {
            $('.product-form__input.product-form__quantity').hide(); // Hide the quantity input for Combo B
            MaxquantityChick = 12;
        } else if (h1Text === "Muscle Gain COMBO C - 22+FREE 2 meals" || h1Text === "Weight Loss COMBO C - 22+FREE 2 meals") {
            $('.product-form__input.product-form__quantity').hide(); // Hide the quantity input for Combo C
            MaxquantityChick = 24;
        }

        if (MaxquantityChick != 0){
            $(".product__description").before(`
              <p class="max-quantity-warning-chick">You may choose up to ${MaxquantityChick} meals</p>
          `);
  
          var previousValues = {};
  
          $(".bold_option_element select").each(function() {
              previousValues[$(this).attr('name')] = $(this).val();
          });
  
          function generateOptions(remainingQuantity, title) {
              let options = `<option value="" aria-selected="false">-- Choose ${title} --</option>`;
              for (let i = 1; i <= remainingQuantity; i++) {
                  options += `<option value="x${i}" aria-selected="false" data-option_value_key="${i-1}">x${i}</option>`;
              }
              return options;
          }
  
          function updateQuantities() {
              var totalQuantityChick = 0;
  
              $(".bold_option_element select").each(function() {
                  var currentSelectName = $(this).attr('name');
                  var valueKey = $(this).find("option:selected").data("option_value_key");
                  totalQuantityChick += valueKey !== undefined ? parseInt(valueKey) + 1 : 0;
              });
  
              console.log(`totalQuantityChick: ${totalQuantityChick}`);
              return { totalQuantityChick };
          }
  
          function updateDropdowns() {
              var quantities = updateQuantities();
              var totalQuantityChick = quantities.totalQuantityChick;
              var remainingQuantity = MaxquantityChick - totalQuantityChick;
  
              $(".bold_option_element select").each(function() {
                  var currentValue = $(this).val();
                  var title = $(this).closest('label').find('.bold_option_title').text().trim();
                  $(this).html(generateOptions(remainingQuantity + (currentValue ? parseInt(currentValue.replace(/\D/g, '')) : 0), title));
                  $(this).val(currentValue);
              });
          }
  
          $(".bold_option_element select").change(function() {
              var selectName = $(this).attr('name');
              var quantities = updateQuantities();
              var totalQuantityChick = quantities.totalQuantityChick;
  
              if (totalQuantityChick > MaxquantityChick) {
                  $(this).val(previousValues[$(this).attr('name')]);
                  alert(`Your selection limit exceeded`);
                  return false;
              } else {
                  previousValues[$(this).attr('name')] = $(this).val();
                  if (totalQuantityChick === MaxquantityChick) {
                      $(".max-quantity-warning-chick").text(`Selection completed`);
                  } else {
                      $(".max-quantity-warning-chick").text(`Left ${MaxquantityChick - totalQuantityChick} meals to choose`);
                  }
                  updateDropdowns();
              }
  
              if (totalQuantityChick === MaxquantityChick && noSubmit === 0) {
                  alert(`Already selected ${MaxquantityChick} meals`);
              }
  
              // If both quantities are reached, display a general message
              if (totalQuantityChick === MaxquantityChick) {
                  $(".max-quantity-warning-chick").text(`Selection completed`);
              }
          });
  
          button.click(function() {
              noSubmit = 1;
  
              var quantities = updateQuantities();
              var totalQuantityChick = quantities.totalQuantityChick;
  
              function evenlyDistributeRemainingQuantity(maxQuantity, totalQuantity, selector) {
                  var remainingQuantity = maxQuantity - totalQuantity;
                  var selects = $(selector).filter(function() {
                      return !$(this).attr('name').includes("+RM");
                  });
                  var numSelects = selects.length;
                  var quotient = Math.floor(remainingQuantity / numSelects);
                  var remainder = remainingQuantity % numSelects;
  
                  selects.each(function(index) {
                      var additionalQuantity = quotient + (index < remainder ? 1 : 0);
                      if (additionalQuantity > 0) {
                          var selectedQuantity = parseInt($(this).val().replace(/\D/g, '')) || 0;
                          $(this).val('x' + (selectedQuantity + additionalQuantity)).change();
                          previousValues[$(this).attr('name')] = $(this).val();
                      }
                  });
              }
  
              if (totalQuantityChick != MaxquantityChick && MaxquantityChick != 0) {
                  evenlyDistributeRemainingQuantity(MaxquantityChick, totalQuantityChick, ".bold_option_element select:not([name*='主食'])");
              }
  
              quantities = updateQuantities();
              totalQuantityChick = quantities.totalQuantityChick;
  
              // Update the warnings after random selection
              if (totalQuantityChick === MaxquantityChick) {
                  $(".max-quantity-warning-chick").text(`Selection completed`);
              } else {
                  $(".max-quantity-warning-chick").text(`Left ${MaxquantityChick - totalQuantityChick} meals to choose`);
              }
  
                // Find and remove elements with names containing '_bold'
              $("input[name*='_bold']").hide();
      
              // Proceed with the form submission
              return true;
  
              console.log(`Final totalQuantityChick: ${totalQuantityChick}`);
          });
  
          updateDropdowns(); // Initial update  
        }

        
    }

    function checkCustomizerLoaded() {
        if ($(".bold_option_element select").length > 0) {
            initializeCustomizer();
        } else {
            setTimeout(checkCustomizerLoaded, 100); // Check again after 100ms
        }
    }

    checkCustomizerLoaded();
});
